import {
	notifications,
	notifyHandlerActions,
} from '../../../lib/notify-handler';

const {
	errorNotifications: {
		AjaxError,
		SocketError,
	},
	successNotifications: {
		Success,
	},
} = notifications;
const {
	notifyHandlerAction,
} = notifyHandlerActions;

export function notifyErrorAction(error, errorMessage) {
	return notifyHandlerAction(new AjaxError(errorMessage));
}

export function notifySocketErrorAction(error, errorMessage) {
	return notifyHandlerAction(new SocketError(errorMessage));
}

export function notifySuccessAction(message) {
	return notifyHandlerAction(new Success(message));
}
